module.exports = __webpack_public_path__ + "static/media/icons_Bilan N‚vralgie Cervico-Brachiale.4d3ab84f.svg";